export default {
  'pages.workbenchDashboard.title': 'Software Factory Workbench',
  'pages.workbenchDashboard.subTitle':
    'A global dashboard for projects, resources, and recent activity across the software factory.',
  'pages.workbenchDashboard.refresh': 'Reload',
  'pages.workbenchDashboard.loadingError':
    'Failed to load workbench data. Please try again later.',
  'pages.workbenchDashboard.partialStatsWarning':
    'Some project code metrics could not be loaded. Totals are based on the available data.',
  'pages.workbenchDashboard.empty': 'No data available',
  'pages.workbenchDashboard.lastUpdatedAt': 'Updated At',
  'pages.workbenchDashboard.kpi.projects': 'Projects',
  'pages.workbenchDashboard.kpi.activeProjects': 'Active Projects (7d)',
  'pages.workbenchDashboard.kpi.applications': 'Applications',
  'pages.workbenchDashboard.kpi.codebases': 'Codebases',
  'pages.workbenchDashboard.kpi.activeAgents': 'Active Agents',
  'pages.workbenchDashboard.kpi.totalCodeLines': 'Total Code Lines',
  'pages.workbenchDashboard.kpi.generatedCodeLines': 'AI Generated Lines',
  'pages.workbenchDashboard.kpi.newCodeLines': 'New Code Lines Today',
  'pages.workbenchDashboard.sections.groupDistribution':
    'Project Group Distribution',
  'pages.workbenchDashboard.sections.resourceComposition':
    'Resource Composition',
  'pages.workbenchDashboard.sections.activityTrend':
    'Platform Activity Trend (7d)',
  'pages.workbenchDashboard.sections.projectSnapshot': 'Project Snapshot',
  'pages.workbenchDashboard.sections.recentLogs': 'Recent Platform Activity',
  'pages.workbenchDashboard.sections.riskBoard': 'Structural Risks',
  'pages.workbenchDashboard.sections.quickActions': 'Quick Actions',
  'pages.workbenchDashboard.charts.group.unGrouped': 'Ungrouped',
  'pages.workbenchDashboard.charts.resource.projects': 'Projects',
  'pages.workbenchDashboard.charts.resource.applications': 'Applications',
  'pages.workbenchDashboard.charts.resource.codebases': 'Codebases',
  'pages.workbenchDashboard.charts.resource.activeAgents': 'Active Agents',
  'pages.workbenchDashboard.risk.noApplications':
    'Projects without applications',
  'pages.workbenchDashboard.risk.noActiveAgents':
    'Projects without active agents',
  'pages.workbenchDashboard.risk.noRecentActivity':
    'Projects with no activity in 14 days',
  'pages.workbenchDashboard.risk.ok':
    'No obvious structural risks detected at the moment.',
  'pages.workbenchDashboard.table.project': 'Project',
  'pages.workbenchDashboard.table.group': 'Group',
  'pages.workbenchDashboard.table.apps': 'Apps',
  'pages.workbenchDashboard.table.agents': 'Active Agents',
  'pages.workbenchDashboard.table.codeLines': 'Code Lines',
  'pages.workbenchDashboard.table.lastActivity': 'Last Activity',
  'pages.workbenchDashboard.quick.projects': 'Project List',
  'pages.workbenchDashboard.quick.devAgents': 'Development Agents',
  'pages.workbenchDashboard.quick.estimationStandards': 'Estimation Standards',
  'pages.workbenchDashboard.log.empty': 'No recent activity',
  'pages.workbenchDashboard.trend.totalOperations': 'Operations',
  'pages.workbenchDashboard.trend.failedOperations': 'Failed Operations',
};
